// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
// Si más adelante usás Firestore o Storage, podés agregarlos aquí también

const firebaseConfig = {
  apiKey: "AIzaSyDKSrnanj78WPoiFc_uhmMWt4PuxeW2V-s",
  authDomain: "sistema-suma-salto.firebaseapp.com",
  projectId: "sistema-suma-salto",
  storageBucket: "sistema-suma-salto.firebasestorage.app",
  messagingSenderId: "379736869050",
  appId: "1:379736869050:web:00c4d0a01fad8da59dda83",
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
// Exportar servicios
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
